const AVATAR_COLORS = [
  "#5B21B6", // brand-purple
  "#0F766E", // brand-teal
  "#C2410C", // brand-orange
  "#1D4ED8", // blue
  "#15803D", // green
  "#B45309", // amber
  "#7C3AED", // violet
  "#0369A1", // sky
];

export function formatCurrency(amount: number, currency = "INR"): string {
  if (currency === "INR") {
    return `₹${amount.toLocaleString("en-IN")}`;
  }
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatRating(rating: number): string {
  return rating.toFixed(1);
}

export function formatCount(count: number): string {
  if (count >= 1000) {
    return `${(count / 1000).toFixed(1)}k reviews`;
  }
  return `${count} review${count === 1 ? "" : "s"}`;
}

export function formatPriceDiff(diff: number): string {
  const abs = Math.abs(diff);
  const formatted = `₹${abs.toLocaleString("en-IN")}`;
  return diff < 0
    ? `${formatted} below average`
    : `${formatted} above average`;
}

export function formatSlots(remaining: number, total: number): string {
  if (remaining === 0) return "Fully booked";
  if (remaining <= 3) return `Only ${remaining} left`;
  return `${remaining} of ${total} slots available`;
}

export function getInitials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join("");
}

export function hashStringToColor(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}
